// 拖拽上传页面

import React, { useState } from 'react';
import { Upload, Table, Divider, message } from 'antd';
import { InboxOutlined } from '@ant-design/icons';

import { validateExcelFile, getInvalidFileTypeMessage } from './utils/fileValidator';

const { Dragger } = Upload;
const DraggerPage = ({ handleCurrentStepAdd, setFile, setFileName }) => {
    // 拖拽行为
    const props = {
        name: 'file',
        deforeUpload: () => {
            return false; // 阻止上传
        },
        onChange(info) {
            const { file } = info;
            const uploadFile = file.originFileObj || file;
            // 获取文件名,并去掉后缀名
            const fullName = file.name;
            const fileName = fullName.lastIndexOf('.') > 0
                ? fullName.substring(0, fullName.lastIndexOf('.'))
                : fullName;
            setFileName(fileName);
            // 验证文件类型
            if (!uploadFile) {
                message.error('未获取到文件对象');
                return;
            }
            if (!validateExcelFile(uploadFile)) {
                message.error(getInvalidFileTypeMessage());
                return;
            }
            setFile(uploadFile);
            handleCurrentStepAdd();
        },
    };

    // 表格数据定义
    const columns = [
        {
            title: '时间(X轴)',
            dataIndex: 'time',
        },
        {
            title: '供水温度(℃)(Y轴曲线1)',
            dataIndex: 'supplyTemperature',
        },
        {
            title: '回水温度(℃)(Y轴曲线2)',
            dataIndex: 'returnTemperature',
        },
    ];
    const data = [
        {
            key: '1',
            time: '2025-01-01 00:00:00',
            supplyTemperature: 40,
            returnTemperature: 30,
        },
        {
            key: '2',
            time: '2025-01-01 00:05:00',
            supplyTemperature: 40.5,
            returnTemperature: 30.5,
        },
        {
            key: '3',
            time: '2025-01-01 00:10:00',
            supplyTemperature: 41,
            returnTemperature: 30.5,
        }];

    return (
        <div style={{ width: '100%' }}>
            <Dragger maxCount={1} accept=".xlsx,.xls,.csv" {...props} style={{ width: '100%' }}>
                <p className="ant-upload-drag-icon" style={{ marginTop: 60 }}>
                    <InboxOutlined />
                </p>
                <p className="ant-upload-text">点击或拖动文件至此区域</p>
                <p className="ant-upload-hint" style={{ marginBottom: 60 }}>
                    支持.xlsx, .xls, .csv格式的文件，单次最多上传1个文件。
                </p>
            </Dragger>
            <Divider plain style={{ marginTop: 40 }}>参考表格样例</Divider>
            <Table columns={columns} dataSource={data} size='middle' bordered={false} pagination={false} />
        </div>
    );
}

export default DraggerPage;